import React, { useEffect, useState } from "react";
import { Transaction } from "../../types/transaction.type";
import { useParams } from "react-router-dom";
import { message, Table, Typography } from "antd";
import { api } from "../../api/api";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

const { Title } = Typography;

export default function Expense() {
  const { startDate, endDate } = useParams();
  const [expenses, setExpenses] = useState<Transaction[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchExpenses = async () => {
    setLoading(true);

    try {
      const response = await api.get(`/stats/expenses`, {
        params: {
          startDate,
          endDate,
        },
      });

      setExpenses(response.data);
    } catch (error) {
      console.log(error);
      message.error("Ошибка получение расходов.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, [startDate, endDate]);

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Тип расхода",
      dataIndex: "expenseType",
      key: "expenseType",
    },
    {
      title: "Станок",
      dataIndex: "machineName",
      key: "machineName",
    },
    {
      title: "Касса",
      dataIndex: "cashboxName",
      key: "cashboxName",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Сумма",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Общ.Прибыль до",
      dataIndex: "netProfitBefore",
      key: "netProfitBefore",
      render: (data: number) => roundToThreeDecimals(data),
    },
    {
      title: "Общ.Прибыль после",
      dataIndex: "netProfitAfter",
      key: "netProfitAfter",
      render: (data: number) => roundToThreeDecimals(data),
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title level={2}>
        Расходы {startDate} - {endDate}
      </Title>

      <Table
        loading={loading}
        columns={columns}
        dataSource={expenses}
        rowKey={(record) => record._id}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}
